<div class="checkout-header">
  @if (isMobileSmDown()) {
    <div class="checkout-header-navigation">
      <button class="color-black btn-icon" tabindex="0" (click)="onNavigationBack()">
        <sd-icon class="icon-size-md-m" [type]="iconTypes.ARROW_PREV"></sd-icon>
      </button>
    </div>
  }

  <ng-content></ng-content>
</div>
